import { sanitizeHTML } from "@/lib/utils";

interface ColumnsSectionData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  content_collection?: {
    id: string;
    site_content_collections_id: {
      collection: {
        collection: string;
        item: {
          title: string;
          text: string;
        };
      }[];
    };
  }[];
}

export const fields = [
  "heading.text",
  "heading.title",
  "text.text",
  "content_collection.id",
  "content_collection.site_content_collections_id.collection.collection",
  "content_collection.site_content_collections_id.collection.item:site_content.title",
  "content_collection.site_content_collections_id.collection.item:site_content.text",
] as const;

interface ColumnsSectionProps {
  data?: ColumnsSectionData;
}

export default function ColumnsSection({ data }: ColumnsSectionProps) {
  if (!data) return null;
  const Wrapper = (data.heading?.text || data.heading?.title) ? 'section' : 'div';

  return (
    <Wrapper className="w-full bg-white">
      <div className="container max-w-screen-2xl mx-auto px-8 py-8 xl:py-24">
        {(data.heading?.text || data.heading?.title || data.text?.text) && (
          <div className="max-w-4xl mx-auto mb-16 md:text-center text-left">
            {(data.heading?.text || data.heading?.title) && (
              <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary mb-9">
                {data.heading?.text || data.heading?.title}
              </h2>
            )}
            {data.text?.text && (
              <div
                className="md:font-light md:leading-[1.6rem] md:text-[1.25rem] text-[1rem] font-normal leading-normal font-greycliff text-primary tracking-tight [&>p]:pb-4 [&>p:last-child]:pb-0 [&_a]:underline [&_a]:transition-all [&_a:hover]:no-underline"
                dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
              />
            )}
          </div>
        )}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 max-w-screen-xl mx-auto">
          {data.content_collection?.map((collection, index) => {
            const titleItem = collection?.site_content_collections_id?.collection.find(
              (item) => item.collection === "site_content" && item.item?.title
            )?.item;
            const textItem = collection?.site_content_collections_id?.collection.find(
              (item) => item.collection === "site_content" && item.item?.text
            )?.item;

            const title = titleItem?.title || "";
            const text = textItem?.text || "";

            return (
              <div key={collection.id ?? index} className="flex flex-col gap-6">
                {title && (
                  <h3
                    className="text-[1.5rem] font-greycliff font-medium text-primary leading-[2rem] tracking-tight"
                    dangerouslySetInnerHTML={sanitizeHTML(title)}
                  />
                )}
                {text && (
                  <div
                    className="md:font-light md:leading-[1.6rem] md:text-[1.25rem] text-[1rem] font-normal leading-normal font-greycliff text-primary tracking-tight [&>p]:pb-4 [&>p:last-child]:pb-0 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:pb-4 [&>ul>li]:mb-2 [&>ul>li:last-child]:mb-0 [&>ol]:list-decimal [&>ol]:pl-6 [&>ol>li]:mb-2 [&>ol>li:last-child]:mb-0 md:[&>*]:font-light md:[&>*]:leading-[1.6rem] md:[&>*]:text-[1.25rem] [&>*]:text-[1rem]! [&>*]:font-normal! [&>*]:leading-normal! [&_a]:underline [&_a]:transition-all [&_a:hover]:no-underline"
                    dangerouslySetInnerHTML={sanitizeHTML(text)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </Wrapper>
  );
}
